import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultNumber' })
export class DefaultNumberPipe implements PipeTransform {
  transform(value: number | null): string {
    return value?.toLocaleString() || 'N/A';
  }
}
